import React, { useState } from "react";
import { Lock, Eye, EyeOff } from "@/lib/icons";
import { Input } from "@/components/ui/input";

/**
 * Password input with a show/hide eye toggle. Used everywhere a password is
 * typed — login, registration, reset, change-password. Pass `icon={null}`
 * to drop the left lock icon for tighter layouts.
 */
export default function PasswordField({
  value, onChange, testid, className = "h-11 bg-white/5 border-white/10 text-white",
  required = true, autoComplete, placeholder, icon: Icon = Lock,
}) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      {Icon && <Icon size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40 pointer-events-none" />}
      <Input
        required={required}
        type={show ? "text" : "password"}
        data-testid={testid}
        autoComplete={autoComplete}
        placeholder={placeholder}
        className={`${Icon ? "pl-9" : "pl-4"} pr-10 ${className}`}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <button
        type="button"
        tabIndex={-1}
        onClick={() => setShow((s) => !s)}
        data-testid={testid ? `${testid}-toggle` : undefined}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/40 hover:text-white/70 transition-colors"
        aria-label={show ? "Hide password" : "Show password"}
      >
        {show ? <EyeOff size={15} /> : <Eye size={15} />}
      </button>
    </div>
  );
}
